import script from "./AnalysisSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisSideMenu.vue?vue&type=script&setup=true&lang=js"

import "./AnalysisSideMenu.vue?vue&type=style&index=0&id=56945db0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56945db0"]])

export default __exports__